import React from "react";
import {Col, ColorPicker, Row, Space} from "antd";
import {ColumnProps} from "antd/es/table";
import Moment from "moment";
import {formatToCurrencyType} from "helper/common";
const columns: ColumnProps<any>[] = [
  {
    key: "2",
    title: "Mã loại thuốc",
    dataIndex: "id",
    align: "left",
    width: 80,
  },
  {
    key: "maThuocBHYT",
    title: "Mã thuốc theo BHYT",
    dataIndex: "maThuocBHYT",
    align: "left",
    width: 80,
  },
  {
    key: "maLoaiThuocBHYT",
    title: "Mã nhóm thuốc theo BHYT",
    dataIndex: "maLoaiThuocBHYT",
    align: "left",
    width: 80,
  },
  {
    key: "duongDung",
    title: "Đường dùng",
    dataIndex: "duongDung",
    align: "left",
    width: 80,
  },
  {
    key: "3",
    title: "Tên thuốc",
    dataIndex: "name",
    align: "left",
  },
  {
    key: "4",
    title: "Số đăng kí",
    dataIndex: "soDangKy",
    align: "left",
  },
  {
    key: "5",
    title: "Bảo hiểm chi trả (VNĐ)",
    dataIndex: "bhChiTra",
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
    align: "right",
  },
  {
    key: "6",
    title: "Hoạt chất",
    dataIndex: "hoatChat",
    align: "left",
  },
  {
    key: "7",
    title: "Nồng độ/Hàm lượng",
    dataIndex: "hamLuong",
    align: "left",
  },
  {
    key: "8",
    title: "Loại thuốc",
    dataIndex: "loaiThuoc",
    align: "left",
  },
  {
    key: "9",
    title: "Là stend",
    dataIndex: "isStend",
    align: "left",
    render(value, record, index) {
      return <>{value == true ? "Có" : "Không"}</>;
    },
  },
  {
    key: "10",
    title: "Đơn vị chính",
    dataIndex: "donViTinh",
    align: "left",
  },

  {key: "11", title: "Thao tác", dataIndex: "action", width: 80},
];
export {columns};
